import { OptimizedCalculations } from '../utils/optimizedCalculations';
import { useGameStore } from './gameStore';

const calculations = OptimizedCalculations.getInstance();

// Optimierte Wrapper-Funktionen für den bestehenden gameStore
export const useOptimizedCalculations = () => {
  const gameStore = useGameStore();
  
  // Optimierte Click Multiplier Berechnung
  const getClickMultiplierOptimized = () => {
    const state = gameStore;
    return calculations.calculateClickMultiplier(state);
  };
  
  // Optimierte Coins Per Second Berechnung
  const getTotalCoinsPerSecondOptimized = () => {
    const state = gameStore;
    return calculations.calculateCoinsPerSecond(state);
  };
  
  // Cache invalidieren
  const invalidateCache = () => {
    calculations.clearCache();
  };
  
  // Cache-Statistiken (für Debugging)
  const getCacheStats = () => {
    return calculations.getCacheStats();
  };
  
  // Performance-Logging
  const logPerformanceStats = () => {
    const stats = getCacheStats();
    console.log('🎯 Performance Stats:', {
      cacheSize: stats.size,
      hitRate: stats.hitRate,
      timestamp: new Date().toISOString(),
    });
  };
  
  return {
    // Original gameStore
    ...gameStore,
    
    // Optimierte Berechnungsfunktionen
    getClickMultiplierOptimized,
    getTotalCoinsPerSecondOptimized,
    invalidateCache,
    getCacheStats,
    logPerformanceStats,
    
    // Optimierte incrementClick Funktion
    incrementClickOptimized: () => {
      const clickMultiplier = getClickMultiplierOptimized();
      const finalAmount = Math.floor(gameStore.clickPower * clickMultiplier);
      
      gameStore.addCoins(finalAmount);
      gameStore.addExperience(1);
      
      // Achievement Update
      gameStore.achievements = {
        ...gameStore.achievements,
        totalClicks: gameStore.achievements.totalClicks + 1,
      };
    },
    
    // Cache-Invalidierung für Begleiter-Änderungen
    setActiveCompanionOptimized: (companion: any, slot: number = 0) => {
      gameStore.setActiveCompanion(companion, slot);
      // Cache invalidieren für hohe Level
      if (gameStore.playerLevel > 5000) {
        invalidateCache();
      }
    },
    
    removeActiveCompanionOptimized: (slot: number) => {
      gameStore.removeActiveCompanion(slot);
      // Cache invalidieren für hohe Level
      if (gameStore.playerLevel > 5000) {
        invalidateCache();
      }
    },

    removeAllActiveCompanionsOptimized: () => {
      gameStore.removeAllActiveCompanions();
      // Cache invalidieren für hohe Level
      if (gameStore.playerLevel > 5000) {
        invalidateCache();
      }
    },
  };
};

// Hook für Performance-Monitoring
export const usePerformanceMonitor = () => {
  const { getCacheStats, invalidateCache } = useOptimizedCalculations();
  
  const logPerformanceStats = () => {
    const stats = getCacheStats();
    console.log('🎯 Performance Stats:', {
      cacheSize: stats.size,
      hitRate: stats.hitRate,
      timestamp: new Date().toISOString(),
    });
  };
  
  const clearCache = () => {
    invalidateCache();
    console.log('🧹 Cache cleared');
  };
  
  return {
    logPerformanceStats,
    clearCache,
  };
}; 